module.exports = __webpack_public_path__ + "img/25761bad-f73c-436d-bc07-670cf37d7270.061.92debfdf.png";